import React from "react";
import { Row, Col, Card, Image } from "antd";
import whatsappIcon from "../../../assets/usageIcons/whatsappIcon.svg";
import aiIcon from "../../../assets/usageIcons/aiIcon.svg";
import smsIcon from "../../../assets/usageIcons/smsIcon.svg";
import emailIcon from "../../../assets/usageIcons/emailIcon.svg";

const UsageSummaryCards = ({ summaryData }) => {
  const summaryValue = summaryData?.counts;
  const STAT_CARDS = [
    {
      label: "Whatsapp Messages",
      value: summaryValue?.whatsapp,
      color: "#7ED63F",
      icon: whatsappIcon,
    },
    {
      label: "AI Requests",
      value: summaryValue?.ai,
      color: "#AB76FF",
      icon: aiIcon,
    },
    {
      label: "SMS",
      value: summaryValue?.sms,
      color: "#23A8FE",
      icon: smsIcon,
    },
    {
      label: "Email",
      value: summaryValue?.email,
      color: "#FFC860",
      icon: emailIcon,
    },
  ];
  return (
    <Row gutter={[27, 16]} style={{ marginBottom: 24 }}>
      {STAT_CARDS.map((card) => (
        <Col xs={24} sm={12} md={8} lg={6} key={card.label}>
          <Card
            bodyStyle={{
              padding: "14px 16px",
            }}
            style={{
              borderRadius: 12,
              height: 144,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              {/* Left Content */}
              <div>
                <div
                  style={{ fontSize: 14, color: "#202224", marginBottom: 4 }}
                >
                  {card.label}
                </div>

                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: card.color,
                    lineHeight: 1,
                  }}
                >
                  {card.value}
                </div>
              </div>

              {/* Icon Box */}

              <Image src={card?.icon} preview={false} />
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default UsageSummaryCards;
